export const dayEnum = {
  0: {
    full: "Sunday",
    abb: "Sun",
  },
  1: {
    full: "Monday",
    abb: "Mon",
  },
  2: {
    full: "Tuesday",
    abb: "Tue",
  },
  3: {
    full: "Wednesday",
    abb: "Wed",
  },
  4: {
    full: "Thursday",
    abb: "Thu",
  },
  5: {
    full: "Friday",
    abb: "Fri",
  },
  6: {
    full: "Saturday",
    abb: "Sat",
  },
};

export const daySelectOptions = () => {
  let opts = [{ label: "Any", value: "" }];
  Object.keys(dayEnum).forEach((d) => {
    opts.push({ label: dayEnum[d].full, value: d });
  });
  return opts;
};

export const dayFromNumber = (number, format) => {
  let targetDay = dayEnum[number];
  return format === "abb" ? targetDay.abb : targetDay.full;
};
